(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-202601"]) return;
  try {
    
    document.querySelectorAll('.site-nav__dropdown-link[href*=\\#]').forEach((ele) => {
      ele.addEventListener('click', (event) => {
        setTimeout(() => {
          document.body.classList.remove('unloading')
        })
      })
    })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-202601"]) return;
  try {
    
  (function () {
    const ON_CHANGE_DEBOUNCE_TIMER = 300;

    const PUB_SUB_EVENTS = {
      cartUpdate: 'cart-update',
      quantityUpdate: 'quantity-update',
      optionValueSelectionChange: 'option-value-selection-change',
      variantChange: 'variant-change',
      cartError: 'cart-error',
    };

    let subscribers = {};

    function subscribe(eventName, callback) {
      if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
      }

      subscribers[eventName] = [...subscribers[eventName], callback];

      return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
          return cb !== callback;
        });
      };
    }

    function publish(eventName, data) {
      if (subscribers[eventName]) {
        const promises = subscribers[eventName]
          .map((callback) => callback(data))
        return Promise.all(promises);
      } else {
        return Promise.resolve()
      }
    }

    const trapFocusHandlers = {};

    function trapFocus(container, elementToFocus = container) {
      var elements = getFocusableElements(container);
      var first = elements[0];
      var last = elements[elements.length - 1];

      removeTrapFocus();

      trapFocusHandlers.focusin = (event) => {
        if (event.target !== container && event.target !== last && event.target !== first) return;

        document.addEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.focusout = function () {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
      };

      trapFocusHandlers.keydown = function (event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
          event.preventDefault();
          first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if ((event.target === container || event.target === first) && event.shiftKey) {
          event.preventDefault();
          last.focus();
        }
      };

      document.addEventListener('focusout', trapFocusHandlers.focusout);
      document.addEventListener('focusin', trapFocusHandlers.focusin);

      elementToFocus.focus();

      if (
        elementToFocus.tagName === 'INPUT' &&
        ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
        elementToFocus.value
      ) {
        elementToFocus.setSelectionRange(0, elementToFocus.value.length);
      }
    }

    class QuantityInput extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true });
        this.input.addEventListener('change', this.onInputChange.bind(this));
        this.querySelectorAll('button').forEach((button) =>
          button.addEventListener('click', this.onButtonClick.bind(this))
        );
      }

      quantityUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.validateQtyRules();
        this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
      }

      disconnectedCallback() {
        if (this.quantityUpdateUnsubscriber) {
          this.quantityUpdateUnsubscriber();
        }
      }

      onInputChange(event) {
        this.validateQtyRules();
      }

      onButtonClick(event) {
        event.preventDefault();
        const previousValue = this.input.value;

        if (event.target.name === 'plus') {
          if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
            this.input.value = this.input.dataset.min;
          } else {
            this.input.stepUp();
          }
        } else {
          this.input.stepDown();
        }

        if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

        if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
          this.input.value = parseInt(this.input.min);
        }
      }

      validateQtyRules() {
        const value = parseInt(this.input.value);
        if (this.input.min) {
          const buttonMinus = this.querySelector(".quantity__button[name='minus']");
          buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
        }
        if (this.input.max) {
          const max = parseInt(this.input.max);
          const buttonPlus = this.querySelector(".quantity__button[name='plus']");
          buttonPlus.classList.toggle('disabled', value >= max);
        }
      }
    }
    if (!customElements.get('quantity-input')) {
      customElements.define('quantity-input', QuantityInput);
    }

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    function throttle(fn, delay) {
      let lastCall = 0;
      return function (...args) {
        const now = new Date().getTime();
        if (now - lastCall < delay) {
          return;
        }
        lastCall = now;
        return fn(...args);
      };
    }

    function fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    }

    class CartPerformance {
      static #metric_prefix = "cart-performance"

      static createStartingMarker(benchmarkName) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        return performance.mark(`${metricName}:start`);
      }

      static measureFromEvent(benchmarkName, event) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const startMarker = performance.mark(`${metricName}:start`, {
          startTime: event.timeStamp
        });

        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
          metricName,
          `${metricName}:start`,
          `${metricName}:end`
        );
      }

      static measureFromMarker(benchmarkName, startMarker) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
          metricName,
          startMarker.name,
          `${metricName}:end`
        );
      }

      static measure(benchmarkName, callback) {
        const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`
        const startMarker = performance.mark(`${metricName}:start`);

        callback();

        const endMarker = performance.mark(`${metricName}:end`);

        performance.measure(
          metricName,
          `${metricName}:start`,
          `${metricName}:end`
        );
      }
    }

    class CartRemoveButton extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', (event) => {
          event.preventDefault();
          const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
          cartItems.updateQuantity(this.dataset.index, 0, event);
        });
      }
    }
    if (!customElements.get('cart-remove-button')) {
      customElements.define('cart-remove-button', CartRemoveButton);
    }

    class CartItems extends HTMLElement {
      constructor() {
        super();
        this.lineItemStatusElement =
          document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

        const debouncedOnChange = debounce((event) => {
          this.onChange(event);
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
      }

      cartUpdateUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'cart-items') {
            return;
          }
          return this.onCartUpdate();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
      }

      setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
      }

      validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;
        let message = '';

        if (inputValue < event.target.dataset.min) {
          message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
        } else if (inputValue > parseInt(event.target.max)) {
          message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
        } else if (inputValue % parseInt(event.target.step) !== 0) {
          message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
        }

        if (message) {
          this.setValidity(event, index, message);
        } else {
          event.target.setCustomValidity('');
          event.target.reportValidity();
          this.updateQuantity(
            index,
            inputValue,
            event,
            document.activeElement.getAttribute('name'),
            event.target.dataset.quantityVariantId
          );
        }
      }

      onChange(event) {
        this.validateQuantity(event);
      }

      onCartUpdate() {
        if (this.tagName === 'CART-DRAWER-ITEMS') {
          return fetch(`${routes.cart_url}?section_id=cart-drawer`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
              for (const selector of selectors) {
                const targetElement = document.querySelector(selector);
                const sourceElement = html.querySelector(selector);
                if (targetElement && sourceElement) {
                  targetElement.replaceWith(sourceElement);
                }
              }
            })
            .catch((e) => {
              console.error(e);
            });
        } else {
          const mainCartItems = document.getElementById('main-cart-items');
          let sectionId = mainCartItems ? mainCartItems.dataset.id : '';
          return fetch(`${routes.cart_url}?section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector('cart-items');
              this.innerHTML = sourceQty.innerHTML;
            })
            .catch((e) => {
              console.error(e);
            });
        }
      }

      getSectionsToRender() {
        return [
          {
            id: 'main-cart-header',
            section: document.getElementById('main-cart-header').dataset.id,
            selector: '.js-contents-header',
          },
          {
            id: 'main-cart-items',
            section: document.getElementById('main-cart-items').dataset.id,
            selector: '.js-contents-items',
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-live-region-text',
            section: 'cart-live-region-text',
            selector: '.shopify-section',
          },
          {
            id: 'main-cart-footer',
            section: document.getElementById('main-cart-footer').dataset.id,
            selector: '.js-contents-footer',
          },
        ];
      }

      updateQuantity(line, quantity, event, name, variantId) {
        const eventTarget = event.currentTarget instanceof CartRemoveButton ? 'clear' : 'change';
        const cartPerformanceUpdateMarker = CartPerformance.createStartingMarker(`${eventTarget}:user-action`);

        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);

            CartPerformance.measure(`${eventTarget}:paint-updated-sections`, () => {
              const quantityElement =
                document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
              const items = document.querySelectorAll('.cart-item');

              if (parsedState.errors) {
                quantityElement.value = quantityElement.getAttribute('value');
                this.updateLiveRegions(line, parsedState.errors);
                return;
              }

              this.classList.toggle('is-empty', parsedState.item_count === 0);
              const cartDrawerWrapper = document.querySelector('cart-drawer');
              const cartFooter = document.getElementById('main-cart-footer');

              if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
              if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

              this.getSectionsToRender().forEach((section) => {
                if (parsedState.item_count === 0) {
                  if (section.id === 'main-cart-items') {
                    return
                  }
                  if (section.id === 'main-cart-footer') {
                    section.id = 'cart-main'
                    section.selector = '.body'
                  }
                }
                const elementToReplace =
                  document.getElementById(section.id).querySelector(section.selector) ||
                  document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                  parsedState.sections[section.section],
                  section.selector
                );
              });
              
              const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
              let message = '';
              if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                if (typeof updatedValue === 'undefined') {
                  message = window.cartStrings.error;
                } else {
                  message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                }
              }
              this.updateLiveRegions(line, message);

              const lineItem =
                document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
              if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                cartDrawerWrapper
                  ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                  : lineItem.querySelector(`[name="${name}"]`).focus();
              } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
              } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
              }
            });

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
          })
          .catch(() => {
            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
          })
          .finally(() => {
            this.disableLoading(line);
            CartPerformance.measureFromMarker(`${eventTarget}:user-action`, cartPerformanceUpdateMarker);
          });
      }

      updateLiveRegions(line, message) {
        const lineItemError =
          document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

        this.lineItemStatusElement.setAttribute('aria-hidden', true);

        const cartStatus =
          document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
        cartStatus.setAttribute('aria-hidden', false);

        setTimeout(() => {
          cartStatus.setAttribute('aria-hidden', true);
        }, 1000);
      }

      getSectionInnerHTML(html, selector) {
        let innerHTML = '';
        const el = new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
        if (el) {
          innerHTML = el.innerHTML
        }
        return innerHTML;
      }

      enableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        mainCartItems.classList.add('cart__items--disabled');

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

        document.activeElement.blur();
        this.lineItemStatusElement.setAttribute('aria-hidden', false);
      }

      disableLoading(line) {
        const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
        if (mainCartItems) {
          mainCartItems.classList.remove('cart__items--disabled');
        }

        const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
        const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

        cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
        cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
      }
    }
    if (!customElements.get('cart-items')) {
      customElements.define('cart-items', CartItems);
    }

    if (!customElements.get('cart-note')) {
      customElements.define(
        'cart-note',
        class CartNote extends HTMLElement {
          constructor() {
            super();

            this.addEventListener(
              'input',
              debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } }).then(() =>
                  CartPerformance.measureFromEvent('note-update:user-action', event)
                );
              }, ON_CHANGE_DEBOUNCE_TIMER)
            );
          }
        }
      );
    }
  })()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();
})();
